module.exports = __webpack_public_path__ + "img/filters_popup.d62f1e77.svg";